import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-error.magic.css.js';
import script from './keycloak-error.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","content":_vm.$t('keycloak-error.introduction')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","content":_vm.errorMessage}}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-link',{attrs:{"button":"","wide":"","variant":"primary","to":_vm.RoutablePage.HOME},domProps:{"innerHTML":_vm._s(_vm.$t('keycloak-error.button'))}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-51300f1e_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-51300f1e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
